import { Component, OnInit, signal, computed } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Actions, ofType } from '@ngrx/effects';
import { State } from '../../../../core/store';
import { Store } from '@ngrx/store';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { FullTimeStatusCheckModel } from '../../../../models/fullTimeStatusCheckModel';
import { exportEmployeeFullTimeStatusListToExcel, exportEmployeeFullTimeStatusListToExcelSuccess, getFullTimeStatusCheckList, loadEmployeeUsers, loadViewableCampuses } from '../../../../core/store/employee/employee.action';
import { DateRangeModel } from '../../../../models/dateRangeModel';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';
import { CustomFilterModel } from '../../../../models/customFilterModel';
import { deepClone, downloadFile } from '../../../../helpers/utils';
import { tap } from 'rxjs';
import { UserAutoCompleteItem, ModifiedSelectItem } from '../../../../models/utilModels';

@Component({
    selector: 'app-list-report-fulltimestatus',
    templateUrl: './list-report-fulltimestatus.component.html',
    styleUrls: ['./list-report-fulltimestatus.component.scss'],
    standalone: false
})
export class ListReportFulltimestatusComponent extends BaseComponent implements OnInit {
  checks: PagingResultsModel<FullTimeStatusCheckModel>;
  filter: any;
  canEdit: boolean = false;

  loadingStatusList: boolean = true;
  loadingStatusExcel: boolean = false;

  campusList: ModifiedSelectItem[];
  campusId: number = 0;

  selectedUserEmployee: UserAutoCompleteItem;
  userEmployeeList: UserAutoCompleteItem[];
  userId: number = 0;

  dateRangeList: DateRangeModel[];
  dateRange: DateRangeModel;
  startDate: string = null;
  endDate: string = null;
  isCustomDateRange: boolean = false;

  hourRangeList: CustomFilterModel[];
  hourRange: CustomFilterModel;
  minHours: string = null;
  maxHours: string = null;
  isCustomHourRange: boolean = false;

  fullTimeStatusOptions: ModifiedSelectItem[];
  fullTimeStatus: string = null;

  includeInactive: boolean = false;
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private dropdownFilterService: DropdownFilterService) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.employeeState.loadingStatusList).subscribe(loadingStatusList => {
        this.loadingStatusList = loadingStatusList;
      }),
      this.store.select(s => s.employeeState.loadingFullTimeStatusExcel).subscribe(loadingStatusExcel => {
        this.loadingStatusExcel = loadingStatusExcel;
      }),
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 3071);
      }),
      this.store.select(s => s.employeeState.campuses).subscribe(campuses => {
        this.campusList = campuses && campuses.length > 0 ? campuses
          : [{ label: 'loading...', value: undefined }];
      }),
      this.store.select(s => s.employeeState.employeeUsers).subscribe(users => {
        this.userEmployeeList = users.map(x => ({
          id: x.value,
          name: x.label
        }));
      }),      
      this.store.select(s => s.employeeState.statusList).subscribe(statusList => {
        this.checks = statusList;
        if(statusList != null)
          this.totalRecords.set(statusList.totalRecords);
      }),
      this.actions$.pipe(
        ofType(exportEmployeeFullTimeStatusListToExcelSuccess),
        tap(action => {
          downloadFile(action.doc, 'EmployeeFullTimeStatus.xlsx');
        })
      ).subscribe()
    );

    this.dateRangeList = this.dropdownFilterService.getLast120DayDateRanges();
    if (this.dateRangeList && this.dateRangeList.length > 0) {
      this.dateRange = this.dateRangeList[0];
    }
    this.hourRangeList = this.dropdownFilterService.getFullTimeHourRanges();
    if (this.hourRangeList && this.hourRangeList.length > 0) {
      this.hourRange = this.hourRangeList[0];
    }
    this.fullTimeStatusOptions = [
      { label: 'All', value: null },
      { label: 'Full', value: 'FULL' },
      { label: 'Part', value: 'PART' },
      { label: 'Exempt', value: 'EXEMPT' }
    ];
    this.store.dispatch(loadViewableCampuses());
  }

  changedDateRange() {
    if (this.dateRange.isCustom) {
      this.isCustomDateRange = true;
      return; //reload after manually changing date
    }

    this.isCustomDateRange = false;
    this.startDate = this.dateRange.startDate;
    this.endDate = this.dateRange.endDate;
    this.reloadChecks(this.filter);
  }

  changedHourRange() {
    if (this.hourRange.isCustom) {
      this.isCustomHourRange = true;
      return; //reload after manually changing date
    }

    this.isCustomHourRange = false;
    this.minHours = this.hourRange.minValue;
    this.maxHours = this.hourRange.maxValue;
    this.reloadChecks(this.filter);
  }


  reloadChecks(event) {
    this.filter = event;
    this.store.dispatch(getFullTimeStatusCheckList({
      filter: this.filter,
      userId: this.userId,
      programId: this.campusId,
      startDate: this.startDate,
      endDate: this.endDate,
      minHours: this.minHours,
      maxHours: this.maxHours,
      fullTimeStatus: this.fullTimeStatus,
      includeInactive: this.includeInactive
    }));
  }

  getStaffList(event) {
    this.store.dispatch(loadEmployeeUsers({
      prefixText: event.query,
      programId: this.campusId,
      payrollClassificationId: null,
      showInactive: this.includeInactive,
      showTerminated: this.includeInactive
    }));
  }

  reloadListAfterStaffChage(selectedUser) {
    if (typeof selectedUser.value.id !== 'number') {
      return;
    }

    this.userId = selectedUser.value.id;
    this.reloadChecks(this.filter);
  }

  reloadListAfterClear(event) {
    
    this.userId = 0;
    this.reloadChecks(this.filter);
  }

  exportToExcel() {
    this.filter = deepClone(this.filter);
    this.filter.filters.userId = { Name: 'userId', Value: { value: this.userId.toString() } };
    this.filter.filters.programId = { Name: 'programId', Value: { value: this.campusId.toString() } };
    this.filter.filters.startDate = { Name: 'startDate', Value: { value: this.startDate } };
    this.filter.filters.endDate = { Name: 'endDate', Value: { value: this.endDate } };
    this.filter.filters.minHours = { Name: 'minHours', Value: { value: this.minHours } };
    this.filter.filters.maxHours = { Name: 'maxHours', Value: { value: this.maxHours } };
    this.filter.filters.fullTimeStatus = { Name: 'fullTimeStatus', Value: { value: this.fullTimeStatus } };

    this.store.dispatch(exportEmployeeFullTimeStatusListToExcel({
      filter: this.filter
    }));
  }

}
